import { formRules } from '@/helpers/tools';

/**
 * Helper mixin to easily create a form rules array:
 *
 * The component method 'getRules' can be used to create a form rules array,
 * from the available form rules defined in helpers/tools/formRules:
 *
 * <code>
 *   <v-text-field :rules="getRules('required', 'email')"
 * </code>
 */
const getFormRules = {
    methods: {
        getRules(...rules: string[]) {
            const rulesArr: any[] = [];
            rules.forEach((r) => {
                if (formRules[r]) {
                    rulesArr.push(formRules[r]);
                }
            });

            return rulesArr;
        },
        getRule(rule: string) {
            return formRules[rule];
        },
    },
};

export default getFormRules;
